import { prepareQueryArrayParam } from 'shared/utils';
import { usersApi } from 'entities/users';
import { UserProfileSalesPoints, UserProfileType } from 'entities/user/model/types';
import { UsersListType } from 'shared/types';

const getAppTypeString = (arr: string[]) => {
  let res = '';
  arr.map((item) => {
    res += `&app_type=${item}`;
  });
  return res;
};

const getUsersApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getUsers: builder.query<
      UsersListType,
      {
        app_type: string;
        page: number;
        size: number;
        search: string;
        city: Array<string | number>;
        country: Array<string | number>;
        sort: string;
        sort_desc: boolean;
      }
    >({
      query: ({ app_type, page, size, search, city, country, sort, sort_desc }) => ({
        url: `/account/admin/users/?${app_type ? `app_type=${app_type}` : ''}&page=${page}&size=${size}${
          search ? `&search=${search.trim()}` : ''
        }${city.length ? `&${prepareQueryArrayParam('city', city)}` : ''}${
          country.length ? `&${prepareQueryArrayParam('country', country)}` : ''
        }${sort ? `&sort=${sort}` : ''}&sort_desc=${sort_desc}`,
      }),
      providesTags: ['Users'],
    }),
    getUser: builder.query<UserProfileType, string>({
      query: (id) => ({
        url: `/account/admin/users/${id}`,
      }),
      providesTags: (result, error, arg) => (result ? [{ type: 'User' as const, id: arg }, 'User'] : ['User']),
    }),
    getUserSalesPoints: builder.query<
      UserProfileSalesPoints,
      { user_id: number; page: number; size: number; search: string }
    >({
      query: ({ user_id, page, size, search }) => ({
        url: `/sales-point/admin/sales-point/admin/sales-points/?user__user_id__in=${user_id}&page=${page}&order_by=id&size=${size}${
          search ? `&search=${search}` : ''
        }`,
      }),
      providesTags: (result, error, arg) => (result ? [{ type: 'User' as const, user_id: arg }, 'User'] : ['User']),
    }),
    getUsersAppType: builder.query<UsersListType, { app_type: string[] }>({
      query: ({ app_type }) => ({
        url: `/account/admin/users/?sort_desc=false&size=100${getAppTypeString(app_type)}`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetUsersQuery, useGetUserQuery, useGetUsersAppTypeQuery, useGetUserSalesPointsQuery } = getUsersApi;
